<!--floatDialogTz-->
<template>
  <div id="floatDialogTz" v-if="showFloatDialog">
    <div class="iconTop">
      <el-icon color="#fff" size="30"><caret-top /></el-icon>
    </div>
    <div class="floatDialogTzDeail" :style="{ width: wd }">
      <el-card class="box-card">
        <template #header>
          <div class="card-header">
            <span> 通知({{ newsList.length }}条未读) </span>
            <span> </span>
            <!-- 全部标记已读 -->
          </div>
        </template>
        <div
          class="card-content"
          v-for="o in newsList"
          :key="o"
          @click="RouterClick()"
        >
          <span> {{ o.creater }}</span>
          <span> {{ moment(o.sendTime).format("YYYY-MM-DD ") }}</span>
        </div>
        <div class="bottomqb" @click="RouterClick()">查看全部通知</div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs, onMounted, ref } from "vue";
import { CaretTop } from "@element-plus/icons-vue";
import { useRouter } from "vue-router";
import moment from "moment";
import { useContext, createContext } from "@/hooks/core/useContext.js";
import { notifymessageMymessage } from "@/api/messageCenter/messageCenterApi.js";
import { notifymessageunread_message } from "@/api/messageCenter/messageCenterApi.js";
export default defineComponent({
  name: "floatDialogTz",
  components: { CaretTop },
  props: {
    showFloatDialog: {
      type: Boolean,
      default: false,
    },
    wd: {
      type: String,
      default: "11vw",
    },
    leftValue: {
      type: String,
      default: "100px",
    },
  },
  setup(props, context) {
    const state = reactive({
      notificationParams: {
        limit: 10,
        page: 1,
        status: 0,
      },
      newsList: [],
    });
    const refData = toRefs(state);
    const router = useRouter();
    const socket = useContext("socket");
    socket.on("connect", function (e) {
      console.log("e", e);
    });
    const getNotifyMessage = async () => {
      const res = await notifymessageunread_message(state.notificationParams);
      console.log(res);
      if (res.code == 0) {
        state.newsList = res.page.list.filter((item) => {
          return item.status == "0";
        });
        context.emit("newListNum", state.newsList.length);
      }
    };
    getNotifyMessage();
    const RouterClick = () => {
      router.push("messageNotification");
    };
    return {
      ...refData,
      RouterClick,
      moment,
    };
  },
});
</script>
<style lang="scss" scoped>
@import "~@/assets/style/utils";
#floatDialogTz {
  height: auto;
  position: absolute;
  z-index: 1000;
  top: 5vh;
  left: 0px;
  border-radius: 10px;
  color: #000;
  height: 300px;
  // overflow: auto;
  background: #fff;
  // z-index: 2;
  font-size: 0.14rem;
  // color: var(--info);
  // border: 1px solid #f5f5f5;
  // box-shadow: 0 0 0.2rem rgab(0, 0, 0, 0.1);
  -moz-box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* 老的 Firefox */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  .floatDialogTzDeail {
    height: 100%;
    .el-card {
      height: 100%;
      border-radius: 10px;
      :deep(.el-card__header) {
        padding: 10px !important;
      }
    }
    .box-card {
      position: relative;
      .card-header {
        display: flex;
        justify-content: space-between;
      }
      .bottomqb {
        position: absolute;
        bottom: 10px;
        width: 85%;
        text-align: center;
        margin: 0 auto;
      }
      .card-content {
        @include flex-row-sb-c;
      }
    }
  }
  .iconTop {
    position: absolute;
    top: -2vh;

    left: 10px;
    width: 100%;
    // padding-left: 200px;
    box-sizing: border-box;
  }
}
@mixin bg($path) {
}
.simple {
  @include bg("simple");
}
</style>
